import { Link, useParams } from "react-router-dom";
import { URL } from "../../../../../routers/constants";
import { useEffect } from "react";
import { connect } from "react-redux";
import { fetchFaq, fetchFaqs, handleUpdateFaq, onChange } from "../../../../../store/action/faqAction";
import ChatBot from "../../../../shared/components/ChatBot";
const _ = require('lodash');

const Faq = (props) => {
   const { faq, fetchFaq, onChange, page, handleUpdateFaq, fetchFaqs } = props;
   const params = useParams();
   const { id } = params;

   useEffect(() => {
      if (!_.isEmpty(page)) {
         fetchFaq(id);
      }
   }, [id, page]);

   const handleUpdate = () => {
      handleUpdateFaq(() => { })
   }

   return (
      <div id="bot-scene-container" className="chat-assistant">
         <div id="bot-scene-content" className="scroll-light">
            <div className="app-v2-header-wrapper has-extra">
               <div className="app-v2-header-left">
                  <div className="app-v2-breadcrumb-wrapper app-v2-header-breadcrumb">
                     <span className="app-v2-header-breadcrumb-item">
                        <span className="app-v2-breadcrumb-link">
                           <Link to={URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ} className="active">
                              Câu hỏi thường gặp
                           </Link>
                        </span>
                        <span className="app-v2-breadcrumb-separator">
                           <div className="svg-next-icon ic-breadcrumb-separator">
                           </div>
                        </span>
                     </span>
                     <span className="app-v2-header-breadcrumb-item active">
                        <span className="app-v2-breadcrumb-link">
                           <span title={faq.name}>
                              {faq.name}
                           </span>
                        </span>
                        <span className="app-v2-breadcrumb-separator">
                           <div className="svg-next-icon ic-breadcrumb-separato">
                           </div>
                        </span>
                     </span>
                  </div>
               </div>
               <div className="app-v2-header-extra-wrapper">
                  <div className="app-v2-header-extra-item">
                     <div>
                        <button className="btn btn-primary app-v2-btn-icon" onClick={handleUpdate}>
                           <span className="btn-icon-wrapper">
                              <span>
                                 <div className="svg-next-icon mr5 ic-save">
                                 </div>
                              </span>
                              <span>
                                 Lưu &amp; quay lại
                              </span>
                           </span>
                        </button>
                     </div>
                  </div>
               </div>
            </div>
            <div className="app-v2-layout-content" style={{ backgroundColor: 'white' }}>
               <div>
                  <div className="col-auto">
                     <div className="message-flow-editor show-block-info">
                        <ChatBot
                           data={faq}
                           onChange={onChange}
                        />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
const mapStateToProps = state => {
   const { faq, page } = state;
   return {
      faq: faq.faq,
      page
   }
}
export default connect(mapStateToProps, {
   fetchFaq,
   onChange,
   handleUpdateFaq,
   fetchFaqs
})(Faq);